var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserCicrleDuotone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 17.5C4.375 10.2513 10.2513 4.375 17.5 4.375C24.7487 4.375 30.625 10.2513 30.625 17.5C30.625 24.7487 24.7487 30.625 17.5 30.625C10.2513 30.625 4.375 24.7487 4.375 17.5Z",
    fill: "#1B75BC",
    fillOpacity: 0.21
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.4998,
    cy: 14.5833,
    r: 5.83333,
    fill: "#1B9FBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6167 26.6841C26.6739 26.7811 26.6562 26.9042 26.5749 26.9821C24.2177 29.2387 21.0206 30.625 17.4998 30.625C13.979 30.625 10.782 29.2387 8.42484 26.9822C8.34355 26.9043 8.32584 26.7812 8.38299 26.6843C10.0648 23.8313 13.5158 21.875 17.4999 21.875C21.4839 21.875 24.9349 23.8312 26.6167 26.6841Z",
    fill: "#1B9FBC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCicrleDuotone);
export default __webpack_public_path__ + "static/media/user_cicrle_duotone.cc2768ad5b5f6b0de30ba4ead900b1c5.svg";
export { ForwardRef as ReactComponent };